export default {
  order: 6,
  layerGroupId: 'GROUP_LCD',
  dataLayer: {
    id: 'TERRA_I_ALERTS',
    order: 6,
    type: 'remoteDataLayer',
    uuid: '1fc7b0c5-259a-4685-8665-b2f1ed3f808f',
    groupId: 'GROUP_LCD',
  },
  layer: {
    sublabel: {
      ka: '(თვიური, 250 მ, ტროპიკები, CIAT)',
      zh: '（每月，250m，热带地区，CIAT）',
      id: '(bulanan, 250m, tropis, CIAT)',
      pt: '(mensal, 250 m, trópicos, CIAT)',
      es: '(mensual, 250 m, trópicos, CIAT)',
      fr: '(mensuelles, 250 m, tropiques, CIAT)',
      en: '(monthly, 250m, tropics, CIAT)',
    },
    label: {
      ka: 'Terra-I შეტყობინებები',
      zh: 'Terra-I 预警',
      id: 'Peringatan Terra-I',
      pt: 'Alertas Terra-I',
      es: 'Alertas Terra-I',
      fr: 'Alertes Terra-I',
      en: 'Terra-I Alerts',
    },
    maxZoom: 10,
    legendLayer: [13],
    technicalName: 'terra_i_alerts',
    url: 'https://wri-tiles.s3.amazonaws.com/terrai_prod/tiles/{z}/{x}/{y}.png',
    type: 'terra',
    id: 'TERRA_I_ALERTS',
    metadata: {
      metadata: null,
      legendConfig: {
        name: {
          ka: 'Terra-I შეტყობინებები',
          zh: 'Terra-I 预警',
          id: 'Peringatan Terra-I',
          pt: 'Alertas Terra-I',
          es: 'Alertas Terra-I',
          fr: 'Alertes Terra-I',
          en: 'Terra-I Alerts',
        },
        type: 'basic',
        items: [
          {
            outlineColor: '#555555',
            color: '#DC6699',
            name: {
              ka: 'Terra-I შეტყობინებები',
              zh: 'Terra-I 预警',
              id: 'Peringatan Terra-I',
              pt: 'Alertas Terra-I',
              es: 'Alertas Terra-I',
              fr: 'Alertes Terra-I',
              en: 'Terra-I Alerts',
            },
          },
        ],
      },
      interactionConfig: {},
    },
  },
  isMetadataError: false,
  isError: false,
};
